export const isValidEmail = (email: string) => {
  const emailRegex: RegExp =
    /^[a-zA-Z0-9._%+'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return emailRegex.test(email);
};

// Better Auth's minimum and ora-be's cap (ORA-987). Legacy passwords
// shorter than 8 still sign in; only new passwords must meet the minimum.
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 128;

export const isValidPassword = (password: string) => {
  return (
    password.length >= PASSWORD_MIN_LENGTH &&
    password.length <= PASSWORD_MAX_LENGTH
  );
};

/** Why a new password is refused, or null when it is acceptable. */
export const getPasswordPolicyError = (password: string): string | null => {
  if (password.length < PASSWORD_MIN_LENGTH) {
    return `Password must be at least ${PASSWORD_MIN_LENGTH} characters.`;
  }
  if (password.length > PASSWORD_MAX_LENGTH) {
    return `Password must be at most ${PASSWORD_MAX_LENGTH} characters.`;
  }
  return null;
};
